module.exports = __webpack_public_path__ + "img/baner5.3c8cba4a.png";